import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import AuthDialog from "../components/AuthDialog";
import { VipIntro } from "../components/vip/VipIntro";
import { VipBenefits } from "../components/vip/VipBenefits";
import { VipSignupGuide } from "../components/vip/VipSignupGuide";
import { VipClaimBanner } from "../components/vip/VipClaimBanner";
import { VipOriginals } from '../components/vip/VipOriginals';
import "../components/vip/vip.css";

export default function VipRewards() {
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  const openAuth = (mode) => { setAuthMode(mode); setAuthOpen(true); };

  return (
    <div className="vip-page" data-testid="vip-rewards-page">
      <Sidebar onAuth={openAuth} />
      <div className="content-shift pt-16">
        <main className="vip-main">
          <VipIntro />
          <VipBenefits />
          <VipOriginals />
          <VipClaimBanner />
          <VipSignupGuide />
        </main>
        <Footer />
      </div>
      <AuthDialog open={authOpen} onOpenChange={setAuthOpen} mode={authMode} setMode={setAuthMode} />
    </div>
  );
}